import { Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { useQuote } from "../context/QuoteCart";

const ProductTile = ({ item, cat, onClick, compact = false }) => {
  const label = compact && item.code ? item.code : item.name;
  const { has, toggle } = useQuote();
  const qItem = { name: item.name, category: cat?.name || "", code: item.code || "", image: item.image };
  const inCart = has(qItem);
  const slug = (item.code || item.name).toLowerCase().replace(/[^a-z0-9]+/g, "-");

  const onToggle = (e) => {
    e.stopPropagation();
    toggle(qItem);
    if (inCart) toast("Teklif sepetinden çıkarıldı", { description: item.name });
    else toast.success("Teklif sepetine eklendi", { description: item.name });
  };

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKey}
      data-testid={`product-tile-${slug}`}
      className="group w-full h-full text-left bg-paper p-4 sm:p-5 flex flex-col cursor-pointer transition-colors duration-300 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
    >
      <div className="relative aspect-square overflow-hidden bg-plate">
        <img
          src={item.image}
          alt={item.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
        />
        <span className="absolute inset-0 ring-1 ring-inset ring-ink/0 group-hover:ring-ink/10 transition-all duration-300" />
        <button
          type="button"
          onClick={onToggle}
          aria-label={inCart ? "Teklif sepetinden çıkar" : "Teklif sepetine ekle"}
          data-testid={`add-quote-${slug}`}
          className={`absolute top-2 right-2 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
            inCart
              ? "bg-brand text-white opacity-100"
              : "bg-white/95 text-ink hover:bg-ink hover:text-white shadow-sm opacity-100 sm:opacity-0 sm:group-hover:opacity-100 sm:focus:opacity-100"
          }`}
        >
          {inCart ? <Check size={15} /> : <Plus size={15} />}
        </button>
      </div>
      <div className={`mt-4 flex-1 flex flex-col ${compact ? "items-center text-center" : ""}`}>
        <p
          className={`font-semibold text-ink group-hover:text-brand transition-colors ${
            compact ? "text-[12px] tracking-[0.14em]" : "text-[13.5px] leading-snug"
          }`}
        >
          {label}
        </p>
        {!compact && (
          <p className="text-[12px] text-mute mt-1.5 leading-relaxed">
            {item.sizes.slice(0, 4).join(" · ")}
            {item.sizes.length > 4 && <span className="text-brand"> +{item.sizes.length - 4}</span>}
          </p>
        )}
        {compact && cat && <p className="text-[11px] text-mute mt-1">{cat.name}</p>}
      </div>
    </div>
  );
};

export default ProductTile;
